import { useContext } from 'react';
import { BusinessPartnerContext } from './BusinessPartnerCard';

const BPHeader = () => {
  const { companyName, eoriNumber, bpTypeLabel } = useContext(BusinessPartnerContext);
  return (
    <div className="bp-companydetails-header">
      <div className="cabie-company-info">
        <p>
          <span className="label">Company Name:</span>
          {companyName?.toUpperCase()}
          {bpTypeLabel ? ` (${bpTypeLabel})` : ''}
        </p>
        <p>
          <span className="label">EORI Number:</span>
          {eoriNumber?.toUpperCase()}
        </p>
      </div>
    </div>
  );
};

export default BPHeader;
